var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
export default function Loading(props) {
    var style = props.style, color = props.color, size = props.size;
    return (React.createElement("div", { style: __assign({ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center' }, style) },
        React.createElement(Spin, { indicator: React.createElement(LoadingOutlined, { style: { fontSize: size || 24, color: color } }) })));
}
//# sourceMappingURL=index.js.map